import { render, staticRenderFns } from "./AccordionView.vue?vue&type=template&id=1ee2c955&scoped=true&"
import script from "./AccordionView.vue?vue&type=script&lang=js&"
export * from "./AccordionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee2c955",
  null
  
)

export default component.exports